import { render, staticRenderFns } from "./AdmEdit.vue?vue&type=template&id=5a87c5b3&scoped=true&"
import script from "./AdmEdit.vue?vue&type=script&lang=js&"
export * from "./AdmEdit.vue?vue&type=script&lang=js&"
import style0 from "./AdmEdit.vue?vue&type=style&index=0&id=5a87c5b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a87c5b3",
  null
  
)

export default component.exports